import React from 'react';
import { useSelector } from 'react-redux';

import type { TripModalContext } from '../../../ModalEnum';
import { isTripInstantBooking } from '../../../model/Trip';
import type { ReduxState } from '../../../store';
import Modal from '../../Modal';
import { RestrictionProvider } from '../../Restriction';
import T from '../../Translate';

import InstantBookingTripModalBody from './InstantBookingTripModalBody';
import TripModalBody from './TripModalBody';

interface Props {
  closeModal();
}

export default function TripModal(props: Props) {
  const { trip } = useSelector((state: ReduxState) => state.app.modalOptions?.context) as TripModalContext;

  return (
    <Modal hideCloseButton>
      <RestrictionProvider region={trip.vehicle.country.alpha2_code}>
        <div className="modal-body pb-0 px-4">
          <div className="text-center">
            <div className="dot-info my-4" data-dot-color="success">
              <div className="dot-info--body">
                <i className="icon icon-check" />
              </div>
            </div>
          </div>
          {isTripInstantBooking(trip) ? <InstantBookingTripModalBody /> : <TripModalBody trip={trip} />}
        </div>
        <div className="modal-footer flex-column mt-4 pb-4">
          <button className="btn btn-primary btn-lg px-5" onClick={props.closeModal} type="button">
            <T id="modals.trip.confirmation" />
          </button>
        </div>
      </RestrictionProvider>
    </Modal>
  );
}
